import { render, staticRenderFns } from "./orderCancel.vue?vue&type=template&id=74e1d712&scoped=true&"
import script from "./orderCancel.vue?vue&type=script&lang=js&"
export * from "./orderCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1d712",
  null
  
)

export default component.exports